import * as yup from "yup"

export const maintenanceValidation = yup.object().shape({
    maintenance_schedule : yup.string().label("Maintenance Schedule").required(),
    last_maintenance: yup.string().label("Last Maintenance").required(),
    maintenance_cost: yup.number().label("Next Maintenance").required(),
    asset_maintenance_id: yup.number().label("").optional(),
});

export type MaintenanceType = yup.InferType<typeof maintenanceValidation>